import { CurrencyPipe, NgStyle } from '@angular/common';
import { Component, Inject, Input } from '@angular/core';
import { AppType, ENVIRONMENT, Environment, PaymentDetails, Specification } from '@domains';

import { Designable, DesignService } from '../designable';
import { DonationItemsComponent } from '../donation-items/donation-items.component';
import { ResponsiveService } from '../responsive';

@Component({
  selector: 'rspl-courier-quote',
  templateUrl: './courier-quote.component.html',
  styleUrls: ['./courier-quote.component.scss'],
  imports: [NgStyle, CurrencyPipe, DonationItemsComponent],
})
export class CourierQuoteComponent extends Designable {
  @Input() paymentDetails!: PaymentDetails;
  @Input() discountPaymentDetails!: PaymentDetails;
  @Input() specification!: Specification;
  @Input() discountValid?: boolean;
  @Input() gratuity?: number;
  // RP-4182: non-Uber couriers list the named `donationItems` string ("1 x Sofa (XL), …");
  // Uber and the legacy donor screens (neither passes it) keep the "Bags/boxes" row.
  @Input() donationItems?: string | null;
  /** Small-items courier (Uber): show bag counts instead of the named item list. */
  @Input() smallItemsOnly?: boolean;

  get hasNamedItems(): boolean {
    return this.smallItemsOnly === false && !!this.donationItems;
  }

  isCharityApp: boolean;
  isCaptainApp: boolean;
  app: AppType;

  constructor(
    @Inject(ENVIRONMENT) private config: Environment,
    override designService: DesignService,
    override responsiveService: ResponsiveService,
  ) {
    super(designService, responsiveService);
    this.isCharityApp = this.config.app === AppType.CHARITY;
    this.isCaptainApp = this.config.app === AppType.CAPTAIN || this.config.app === AppType.ZENDESK;
    this.app = this.config.app;
  }
}
